<template>
    <div v-if="filteredFields.length !== 0">
        <div class="my-2">
            <span @click="expand = !expand" class="clickable">
                <span v-tooltip="'Batch update fields with select type'">
                    <i class="fal fa-info-circle"></i>
                </span>
                Properties
                <AppExpandChevron :show="expand" class="pl-2"/>
            </span>
        </div>
        <div v-if="expand" class="row">
            <LineFieldBatchUpdateSelect
                v-for="field in filteredFields" :key="field.path"
                v-tooltip="getFieldTooltip(field)"
                :field="field"
                :getOptions="query => getFieldOptions({field, query})"
                :values="getFieldUniqLineValues(field)"
                :disabled="checkFieldHasDependencyWithMoreThanOneValue(field)"
                class="col-md-4 mb-3"/>
        </div>
    </div>
</template>

<script>
import AppExpandChevron from '../../../../../../components/shared/AppExpandChevron'
import {mapGetters} from 'vuex'
import {FieldEditorTypes} from '@/types/document-viewer/field/modules/editor'
import LineFieldBatchUpdateSelect from './BatchUpdateSelect'
import {getFieldPathMeta} from '@/types/document-viewer/field/modules/path'
import {
    checkFieldSelectOptionsHasPagination,
    FieldEditorOptionsSources,
    getApiSelectQueryStringParamName,
    getFormFieldOptions
} from '@/types/document-viewer/field/modules/editor/select'
import axios from 'axios'
import {AppDocLineTypes} from '@/types/document/lines'
import {getFieldDependencyQueryParams} from '@/types/document-viewer/field/modules/dependencies'

export default {
    name: 'DocumentViewerLinesSelectsBatchUpdate',
    components: {LineFieldBatchUpdateSelect, AppExpandChevron},
    props: {
        isLandedCost: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            expand: false
        }
    },
    computed: {
        ...mapGetters('doc_viewer', [
            'lines',
            'docWithNormalizedParts'
        ]),

        ...mapGetters('doc_viewer_settings', [
            'visibleFields'
        ]),

        filteredFields() {
            return this.visibleFields.filter(f =>
                (this.isLandedCost ? getFieldPathMeta(f.path).isLandedCostLine : getFieldPathMeta(f.path).isLine) &&
                f.editor && f.editor.select && f.editor.select.trackBy && f.editor.select.label &&
                [FieldEditorTypes.DD_SINGLE, FieldEditorTypes.DD_MULTIPLE].includes(f.editor.type)
            )
        }
    },
    methods: {
        getFieldUniqLineValues(field) {
            const meta = getFieldPathMeta(field.path)
            return _.uniqWith(
                this.lines
                    .filter(l => !l.isDeleted && l.type === (this.isLandedCost ? AppDocLineTypes.LANDED_COST : AppDocLineTypes.ITEM))
                    .map(l => _.get(l, meta.isCustom ? `custom.${meta.prop}` : meta.prop)),
                _.isEqual)
        },

        async getFieldOptions({field, query = ''}) {
            const select = field.editor.select
            const params = {}
            if (checkFieldSelectOptionsHasPagination(select)) {
                params[getApiSelectQueryStringParamName(select)] = query
            }
            if (select.source === FieldEditorOptionsSources.API && select.api) {
                if (select.api.attachLineData) {
                    const props = {}
                    let uniqValues
                    let value
                    this.filteredFields.forEach(field => {
                        uniqValues = this.getFieldUniqLineValues(field)
                        value = uniqValues.length === 1 ? uniqValues[0] : null
                        _.set(props, field.path, value)
                    })
                    params.line = _.isPlainObject(props.lines) ? props.lines : {}
                }
            }
            if (field.dependants) {
                params.dependencies = this.getDependencyQueryParams(field)
            }
            let data = []
            try {
                ({data} = await getFormFieldOptions({select, params, requestId: field.path}))
                this.isLoading = false
            } catch (e) {
                if (!axios.isCancel(e)) {
                    this.isLoading = false
                }
            }
            return data
        },

        getDependencyQueryParams(field) {
            return getFieldDependencyQueryParams({
                field,
                docData: this.docWithNormalizedParts
            })
        },

        checkFieldHasDependencyWithMoreThanOneValue(field) {
            const dependencyQueryParams = this.getDependencyQueryParams(field)
            return dependencyQueryParams.some(p => Array.isArray(p.value) && p.value.length > 1)
        },

        getFieldTooltip(field) {
            return this.checkFieldHasDependencyWithMoreThanOneValue(field)
                ? 'This dropdown is disabled because field has dependency on another field with more than one unique value selected'
                : ''
        }
    }
}
</script>
